// ConfirmDelete Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Button from '../button/button.jsx'
import IntlMessage from '../intl/intl_message.jsx'

class ConfirmDelete extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string,
      onClickOk: PropTypes.func,
      className: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      title: '',
      onClickOk: null,
      className: ''
    }
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  onClickOk (e) {
    e.preventDefault()
    if (this.props.onClickOk) {
      this.props.onClickOk(e)
    }
    this.hide()
  }

  onClickCancel (e) {
    e.preventDefault()
    this.hide()
  }

  render () {
    const _classNames = classnames(
      'confirm-delete',
      {
        active: this.state.active
      },
      this.props.className
    )

    return (
      <div className={_classNames}>
        <div className='title'>
          <IntlMessage ident={this.props.title} />
        </div>
        <div className='action'>
          <Button
            icon='confirm-tick'
            className='button_dialog button_confrmok'
            canHover
            onClick={this.onClickOk.bind(this)}
          />
          <Button
            icon='logout-confirm-close'
            className='button_dialog button_confrmno'
            canHover={false}
            onClick={this.onClickCancel.bind(this)}
          />
        </div>
      </div>
    )
  }
}

export default ConfirmDelete
